<script>
   /**************************************************************/
   /* Svelte component for DistancePlot settings                 */
   /**************************************************************/

   import Container from '../../../shared/controls/Container.svelte';
   import Select from '../../../shared/controls/Select.svelte';
   import Range from '../../../shared/controls/Range.svelte';

   export let params;
   export let res;

   let ncomp = 1;
   let showLabels = 'hide';
   let transType = 'no';
   let limType = 'classic';
   let colorBy = 'none';

   $: colorByOptions = res.classNames && res.classNames.length > 1 ? ['none', 'groups'] : null;


   $: params = {
      ncomp,
      showLabels,
      transType,
      limType,
      colorBy
   }
</script>

{#if res  }
<Container label="">
   <p class="title">Distance plot</p>
</Container>

<Container label='# PCs:'>
   <Range id='ncomp' bind:value={ncomp} min={1} max={res.ncomp} step={1} decNum={0} />
</Container>
<Container label='Transform:'>
   <Select id='transType' bind:value={transType} options={['no', 'log']} />
</Container>
<Container label='Limits:'>
   <Select id='limType' bind:value={limType} options={['classic', 'robust']} />
</Container>
<Container label='Labels:'>
   <Select id='showLabels' bind:value={showLabels} options={['hide', 'show']} />
</Container>
{#if colorByOptions}
<Container label='Color by:'>
   <Select id='colorBy' bind:value={colorBy} options={colorByOptions} />
</Container>
{/if}
{/if}

